import { render, staticRenderFns } from "./InfoForm.vue?vue&type=template&id=c80e2e1a"
import script from "./InfoForm.vue?vue&type=script&lang=js"
export * from "./InfoForm.vue?vue&type=script&lang=js"
import style0 from "./InfoForm.vue?vue&type=style&index=0&id=c80e2e1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports